export default "__VITE_ASSET__CyvFREj8__"